import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HiOutlineClipboardCopy } from 'react-icons/hi';
import { toast } from 'react-toastify';

interface ISectionLinksProps {
	customLink: string;
	permanentLink: string;
}

export default function SectionLinks(props: ISectionLinksProps) {
	const { t } = useTranslation();

	return (
		<AccordionItem>
			<AccordionButton>
				<Text fontSize="md" fontWeight="500" as="span" flex="1" textAlign="left">
					{t('Copy and paste an scheduling link')}
				</Text>
				<AccordionIcon />
			</AccordionButton>
			<AccordionPanel pb={4} overflow="auto">
				<Text color="gray.600">{t('Custom link')}</Text>
				<Button
					leftIcon={<HiOutlineClipboardCopy />}
					variant="ghost"
					colorScheme="blue"
					size="xs"
					onClick={() => {
						navigator.clipboard.writeText(props.customLink);
						toast.success(t('Copied to clipboard') as string);
					}}
				>
					{props.customLink}
				</Button>

				<Text color="gray.600">{t('Permanent link')}</Text>
				<Button
					leftIcon={<HiOutlineClipboardCopy />}
					variant="ghost"
					colorScheme="blue"
					size="xs"
					onClick={() => {
						navigator.clipboard.writeText(props.permanentLink);
						toast.success(t('Copied to clipboard') as string);
					}}
				>
					{props.permanentLink}
				</Button>
			</AccordionPanel>
		</AccordionItem>
	);
}
